const personFiles = [
  {projectFileType: 'ID_CARD_FRONT', title: '身份证个人面', filePaths: []},
  {projectFileType: 'ID_CARD_BACK', title: '身份证国徽面', filePaths: []},
  {projectFileType: 'USER_BANK_CARD', title: '银行卡照片', filePaths: []}
];
const perImagesForm = {
  ID_CARD_FRONT: '',
  ID_CARD_BACK: '',
  USER_BANK_CARD: ''
};

const nonpersonFiles = [
  {projectFileType: 'ID_CARD_FRONT', title: '身份证个人面', filePaths: []},
  {projectFileType: 'ID_CARD_BACK', title: '身份证国徽面', filePaths: []},
  {projectFileType: 'USER_BANK_CARD', title: '银行卡照片', filePaths: []},
  {projectFileType: 'HOUSEHOLD_MATERIALS', title: '户籍证明材料', filePaths: []}
];
const nonperImagesForm = {
  ID_CARD_FRONT: '',
  ID_CARD_BACK: '',
  USER_BANK_CARD: '',
  HOUSEHOLD_MATERIALS: ''
};

const perRules = {
  ID_CARD_FRONT: [
    { required: true, message: '请上传身份证个人面', trigger: 'change'}
  ],
  ID_CARD_BACK: [
    { required: true, message: '请上传身份证国徽面', trigger: 'change'}
  ],
  USER_BANK_CARD: [
    { required: true, message: '请上传银行卡照片', trigger: 'change'}
  ],
  HOUSEHOLD_MATERIALS: [
    { required: true, message: '请上传户籍证明材料', trigger: 'change'}
  ]
};
// 单位用户注册
const companyFiles = [
  {projectFileType: 'ID_CARD_FRONT', title: '法定代表人身份证个人面', filePaths: []},
  {projectFileType: 'ID_CARD_BACK', title: '法定代表人身份证国徽面', filePaths: []},
  {projectFileType: 'ASSIGNOR_ID_CARD_FRONT', title: '被授权人身份证个人面', filePaths: []},
  {projectFileType: 'ASSIGNOR_ID_CARD_BACK', title: '被授权人身份证国徽面', filePaths: []},
  {projectFileType: 'LICENSE_IMG', title: '营业执照', filePaths: []},
  {projectFileType: 'CERTIFICATE_IMG', title: '开户许可证', filePaths: []},
  {projectFileType: 'ASSIGNOR_BOOK', title: '授权委托书', filePaths: []}
];

const comImagesForm = {
  ID_CARD_FRONT: '',
  ID_CARD_BACK: '',
  ASSIGNOR_ID_CARD_FRONT: '',
  ASSIGNOR_ID_CARD_BACK: '',
  LICENSE_IMG: '',
  CERTIFICATE_IMG: '',
  ASSIGNOR_BOOK: ''
};

const comRules = {
  ID_CARD_FRONT: [
    { required: true, message: '请上传法定代表人身份证个人面', trigger: 'change'}
  ],
  ID_CARD_BACK: [
    { required: true, message: '请上传法定代表人身份证国徽面', trigger: 'change'}
  ],
  ASSIGNOR_ID_CARD_FRONT: [
    { required: true, message: '请上传被授权人身份证个人面', trigger: 'change'}
  ],
  ASSIGNOR_ID_CARD_BACK: [
    { required: true, message: '请上传被授权人身份证国徽面', trigger: 'change'}
  ],
  LICENSE_IMG: [
    { required: true, message: '请上传营业执照', trigger: 'change'}
  ],
  CERTIFICATE_IMG: [
    { required: true, message: '请上传开户许可证', trigger: 'change'}
  ],
  ASSIGNOR_BOOK: [
    { required: true, message: '请上传经办人授权书', trigger: 'change'}
  ]
};

const villageFiles = [
  {projectFileType: 'ID_CARD_FRONT', title: '法定代表人身份证个人面', filePaths: []},
  {projectFileType: 'ID_CARD_BACK', title: '法定代表人身份证国徽面', filePaths: []},
  {projectFileType: 'ASSIGNOR_ID_CARD_FRONT', title: '被授权人身份证个人面', filePaths: []},
  {projectFileType: 'ASSIGNOR_ID_CARD_BACK', title: '被授权人身份证国徽面', filePaths: []},
  {projectFileType: 'LICENSE_IMG', title: '农村集体经济组织登记证', filePaths: []},
  {projectFileType: 'CERTIFICATE_IMG', title: '开户许可证', filePaths: []},
  {projectFileType: 'ASSIGNOR_BOOK', title: '授权委托书', filePaths: []}
];

export {
  companyFiles,
  villageFiles,
  comImagesForm,
  perRules,
  comRules,
  personFiles,
  perImagesForm,
  nonpersonFiles,
  nonperImagesForm
};
